const production = true;
const local = !production;
const debugging = false;
const debugging_view = false

const globals = {
    parameters : {
            debugging : debugging, 
            chatbot_enabled:true,
            sticky3_debug:false,
            festival_enabled:false,
            assistant_helper_collapsed:true,
            local:local,
            top_actu:false,
            app_name:"LCDLP",
            contact_email_store:"contact@patrickm.consulting",
            biblic_context_button:false,
            calendar_context_button:false,
            redux_authent:true,
            first_name_required:false,
            debugging_view: debugging_view
        },
    menu : {
            donate : "Soutenir la mission ...",
            visit_us : "Visiter la croisade de la prière",
            daily_worship : "Méditation du jour",
            /*booklets: "Fascicules",*/
            about_us:"La Croisade ...",
            subscribe:"Adhérer ...",
            lounge:"Mon compte",
            participation:"Festival de la prière",
            bible_read:"Lire la Bible",
            privacy:"Confidentialité",
            //version:{release : "Version 2025-05-26", whatisnew:[{title"1-Authentification unique par vérification de l'adresse email","2- Nom et prénom du déposant ne sont plus obligatoires", "3-L'historique des requêtes est désormais disponible."}
            //version:{release : "2025-05-31", whatisnew:[{title:"Authentification unique par vérification de l'adresse email"},{title:"Nom et prénom du déposant ne sont plus obligatoires"}, {title:"L'historique des requêtes est désormais disponible."}, {title:"Simplification de l'asistant."}]}
            version:{release : "2025-11-24", whatisnew:[{title:"Affichage d'un décompte pour chaque évènement à venir"},{title:"Authentification unique par vérification de l'adresse email"},{title:"Nom et prénom du déposant ne sont plus obligatoires"}, {title:"L'historique des requêtes est désormais disponible."}, {title:"Simplification de l'asistant."}]}
    },
    daily_worship_endpoint : {
        ...(local && {url : 'http://localhost:4008/worship'}),
        ...(production && {url : 'https://daily-service.jesusestlareponsepourtous.org/worship'})
    },
    req_stats_endpoint : {
        ...(local && {url : 'http://localhost:4006/req-stats2'}),
        ...(production && {url : 'https://survey-service.jesusestlareponsepourtous.org/req-stats2'})
    },
    file_list_endpoint : {
        ...(local && {url : 'http://localhost:4009/file-list'}),
        ...(production && {url : 'https://media-service.jesusestlareponsepourtous.org/file-list'})
    },
    subscriber_add_endpoint : {
        ...(local && {url : 'http://localhost:5100/subscriber-add'}),
        ...(production && {url : 'https://mailer.jesusestlareponsepourtous.org/subscriber-add'})
    },
    subscriber_acknowledge_endpoint : {
        ...(local && {url : 'http://localhost:5100/subscriber-acknowledge'}),
        ...(production && {url : 'https://mailer.jesusestlareponsepourtous.org/subscriber-acknowledge'})
    },
     subscriber_mail_broadcast_endpoint : {
        ...(local && {url : 'http://localhost:5100/subscriber-mail-broadcast'}),
        ...(production && {url : 'https://mailer.jesusestlareponsepourtous.org/subscriber-mail-broadcast'})
    },
    participant_add_endpoint : {
        ...(local && {url : 'http://localhost:5100/participant-add'}),
        ...(production && {url : 'https://mailer.jesusestlareponsepourtous.org/participant-add'})
    },
    participant_acknowledge_endpoint : {
        ...(local && {url : 'http://localhost:5100/participant-acknowledge'}),
        ...(production && {url : 'https://mailer.jesusestlareponsepourtous.org/participant-acknowledge'})
    },
    participant_mail_broadcast_endpoint : {
        ...(local && {url : 'http://localhost:5100/participant-mail-broadcast'}),
        ...(production && {url : 'https://mailer.jesusestlareponsepourtous.org/participant-mail-broadcast'})
    },
    bible_text_endpoint : {
        ...(local && {url : 'http://localhost:5001/bible-text'}),
        ...(production && {url : 'https://bible-service.lacroisadedelapriere.org/bible-text'})
    },
    bible_books_endpoint : {
        ...(local && {url : 'http://localhost:5001/bible-books'}),
        ...(production && {url : 'https://bible-service.lacroisadedelapriere.org/bible-books'})
    },
    bible_chapters_endpoint : {
        ...(local && {url : 'http://localhost:5001/bible-chapters'}),
        ...(production && {url : 'https://bible-service.lacroisadedelapriere.org/bible-chapters'})
    },    

    rbq_lst_endpoint : {
        ...(local && {url : 'http://localhost:4003/rbq-lst'}),
        ...(production && {url : 'https://rubriques.jesusestlareponsepourtous.org/rbq-lst'})
    },    

    last_thanks_endpoint : {
        ...(local && {url : 'http://localhost:4007/last-thanks'}),
        ...(production && {url : 'https://thanks-service.jesusestlareponsepourtous.org/last-thanks'})
    },    

    thanks_add_endpoint : {
        ...(local && {url : 'http://localhost:4007/thanks-add'}),
        ...(production && {url : 'https://thanks-service.jesusestlareponsepourtous.org/thanks-add'})
    },    

    req_add_proc_endpoint : {
        ...(local && {url : 'http://localhost:4001/req-add-proc'}),
        ...(production && {url : 'https://requetes.jesusestlareponsepourtous.org/req-add-proc'})
    },    

    req_oth_endpoint : {
        ...(local && {url : 'http://localhost:4001/req-oth'}),
        ...(production && {url : 'https://requetes.jesusestlareponsepourtous.org/req-oth'})
    },    

    get_user_account_endpoint : {
        ...(local && {url : 'http://localhost:4001/get-user-account'}),
        ...(production && {url : 'https://requetes.jesusestlareponsepourtous.org/get-user-account'})
    },    

    req_get_lounge_data_endpoint : {
        ...(local && {url : 'http://localhost:4001/req-get-lounge-data'}),
        ...(production && {url : 'https://requetes.jesusestlareponsepourtous.org/req-get-lounge-data'})
    },    

    req_get_lounge_data_hstr_endpoint : {
        ...(local && {url : 'http://localhost:4001/req-get-lounge-data-hstr'}),
        ...(production && {url : 'https://requetes.jesusestlareponsepourtous.org/req-get-lounge-data-hstr'})
    },    

    req_upd_ett_endpoint : {
        ...(local && {url : 'http://localhost:4001/req-upd-ett'}),
        ...(production && {url : 'https://requetes.jesusestlareponsepourtous.org/req-upd-ett'})
    },    

    req_hst_endpoint : {
        ...(local && {url : 'http://localhost:4001/req-hst-page'}),
        ...(production && {url : 'https://requetes.jesusestlareponsepourtous.org/req-hst-page'})
    },    

    acknowledge_contact_endpoint : {
        ...(local && {url : 'http://localhost:5100/acknowledge-contact'}),
        ...(production && {url : 'https://mailer.jesusestlareponsepourtous.org/acknowledge-contact'})
    },    

    mail_broadcast_endpoint : {
        ...(local && {url : 'http://localhost:5100/mail-broadcast'}),
        ...(production && {url : 'https://mailer.jesusestlareponsepourtous.org/mail-broadcast'})
    },    

    ett_lst_client_endpoint : {
        ...(local && {url : 'http://localhost:4004/ett-lst-client'}),
        ...(production && {url : 'https://etats.jesusestlareponsepourtous.org/ett-lst-client'})
    },    


    share:{
        worship:{
            ...(local && {url : 'http://localhost:3000/dailyworship'}),
            ...(production && {url : 'https://jlrpt.com/dailyworship'})
        },
        complot:{
            ...(local && {url : 'http://localhost:3000/'}),
            ...(production && {url : 'https://jlrpt.com/'})
        },

        complot_description : 'Je partage avec toi, une conférence Complotisme ou Vérité du 14 au 21 mai.',
        worship_description : 'Je partage avec toi, la Méditation du jour.'
    },
    daily_worship_start_date : {
        day : 30,
        month : 3,
        year : 2023,
    },
    weekly : {
        ref:"Psaumes 16.8",
        verse:"J’ai constamment l’Éternel sous mes yeux; quand il est à ma droite, je ne chancelle pas."
    }    
    ,
    mailsync : {
        ...(local && {url : 'http://localhost:4404'}),
        ...(production && {url : 'https://adv-mailer-service.thononadvent.com'})
    },
    datasync_service : {
        ...(local && {url : "http://localhost:8888/datasync-service"}),
        ...(production && {url : 'https://rest.datasync.ovh'})
    },
    datasync :{
        /*DATASYNC*/
        jlrpt_company_guid:"1FF9E337-39E5-8C25-C43E-D331788B53B9",
        media_table_guid:"3B2DD7AF-1F4C-D2E6-D465-97345F9A0AAA",
        /*jlrpt_company_guid:"3",
        media_table_guid:"3",*/
       
        /*  ASUS local */
        ...(local && {
        syncTestUrl : "http://localhost:8888/datasync-service/test.php",
        syncPushUrl : "http://localhost:8888/datasync-service/Sync.php",
        syncStartUrl: "http://localhost:8888/datasync-service/Sync.php?action=syncStart",
        syncPullUrl : "http://localhost:8888/datasync-service/Sync.php?action=syncPull",
        syncMobilePullUrl : "http://localhost:8888/datasync-service/Sync.php?action=syncMobilePull"}),
        
        
        /* Neuronal.bible Production Server */
        ...(production && {
        syncTestUrl : "https://rest.datasync.ovh/test.php",
        syncPushUrl : "https://rest.datasync.ovh/Sync.php",
        syncStartUrl: "https://rest.datasync.ovh/Sync.php?action=syncStart",
        syncPullUrl : "https://rest.datasync.ovh/Sync.php?action=syncPull",
        syncMobilePullUrl : "https://rest.datasync.ovh/Sync.php?action=syncMobilePull"}),
        /**/
    }
}

  //------------------ Simulate click event
  const onClickAssistantHelper = e =>{
    var element = document.querySelector(".rsc-float-button");
    //this.setState({chatbot_help_collapsed:true})
    if (element)
      element.click();
  }

  const authent_form = {
    version : "1.0",
    Rows : [{
    Cols : [{
        Fields : [
        {
        name : "e_mail_admin",
        title : "Votre adresse électronique (e.mail)",
        placeholder : "Votre adresse de courriel",
        input_type : "email",
        value:"",
        min_length : 5,
        max_length : 40,
        required  : true,
        },
        {
        name : "human_captcha",
        placeholder : "Je ne suis pas un robot",
        title : "Votre message",
        input_type : "captcha",
        min_length : -1,
        max_length : -1,
        required  : false,
        }
        ]
    }]
    }]
}

const  traceView = viewName => {
    if (globals.parameters.debugging_view)
        console.info(`View -> ${viewName}`)
}



export {globals, onClickAssistantHelper, authent_form, traceView}
